"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentList = void 0;
const react_1 = __importDefault(require("react"));
const Table_1 = require("../../Table");
const modificators_1 = require("./modificators");
require("./index.scss");
const className = 'allotment-list';
const AllotmentList = (props) => {
    const { tableColumns, tableData, sorting, setSort, setSelectedRows, } = props;
    const tableModificators = (0, modificators_1.useTableModificators)();
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, defaultSortBy: sorting.sortBy, defaultSortOrder: sorting.sortOrder, manualSortBy: true, setSort: setSort, tableModificators: tableModificators, setSelectedRows: setSelectedRows })));
};
exports.AllotmentList = AllotmentList;
//# sourceMappingURL=index.js.map